import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Nav from "../../components/Navbar/Nav";
import Row from "../../components/Movies/Row";
import apiUrl from "../../api/config.json";
import axios from "../../api/axios";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

function Actor() {
	const Actor = styled.div`
		padding: 100px 0;
		position: relative;

		@media (min-width: 768px) {
			display: flex;
			justify-content: flex-start;
		}
		h2 {
			font-size: 27px;
			color: #fff;
		}
		.actor-details {
			padding: 0 20px;

			/* @media (min-width: 768px) {
				margin-left: 20px;
			} */
		}
		.label {
			color: #a7a7a7;
			font-size: 14px;
			font-weight: 500;
			display: inline-block;
			margin-bottom: 5px;
		}
		.label-value {
			color: #fff;
			font-size: 16px;
			margin-bottom: 8px;
			font-weight: 500;
			line-height: 1.4;

			svg {
				margin-right: 5px;
			}
		}
		.actor-aside {
			padding: 0 20px;

			@media (min-width: 768px) {
				flex: 0 0 250px;
				max-width: 250px;
				margin-right: 20px;

				h2.actor-title {
					display: none;
				}
			}
			.profile-img {
				@media (max-width: 768px) {
					text-align: center;

					img {
						height: 250px;
						width: 100%;
						object-fit: cover;
						object-position: center;
					}
				}
				img {
					max-width: 100%;
				}
			}
		}
		.actor-full {
			color: #fff;
			@media (max-width: 768px) {
				h2.actor-title {
					display: none;
				}
			}
			@media (min-width: 768px) {
				flex: 0 0 calc(100% - 290px);
				max-width: calc(100% - 290px);
			}
		}
	`;

	const { id } = useParams();
	const actorId = id;

	const [actor, setActor] = useState([]);
	const [popular, setPopular] = useState([]);
	const [images, setImages] = useState([]);

	const API_KEY = apiUrl.APIKey;
	const base_url = "https://image.tmdb.org/t/p/original";

	const actorRequest = `/person/${actorId}?api_key=${API_KEY}&language=en-US`;
	const getPopular = `/person/${actorId}/combined_credits?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`;
	const getImages = `/person/${actorId}/tagged_images?api_key=${API_KEY}&language=en-US&page=1`;

	useEffect(() => {
		async function getActor() {
			try {
				let request = await axios.get(actorRequest);
				setActor(request.data);
				return request;
			} catch (err) {
				console.log(err.response, "No Movie found?");
			}
		}
		getActor();

		async function getMovies() {
			try {
				let request = await axios.get(getPopular);
				setPopular(getPopular);
				return request;
			} catch (err) {
				console.log(err.response);
			}
		}
		getMovies();

		async function getGallery() {
			try {
				let request = await axios.get(getImages);
				setImages(request.data.results);
				console.log(request.data.results);
				return request;
			} catch (err) {
				console.log(err.response);
			}
		}
		getGallery();
	}, [actorRequest, getPopular, getImages]);

	const today = new Date();
	const birthDate = new Date(actor.birthday);
	const age = today.getYear() - birthDate.getYear();

	return (
		<div>
			<Nav />
			<Actor className="actor-container">
				<div className="actor-aside">
					<div className="profile-img mb-10">
						<img src={`${base_url}${actor.profile_path}`} alt="" />
					</div>
					<h2 className="actor-title mb-15">{actor?.name}</h2>
					<div className="actor-info mb-15">
						<span className="label">Known For</span>
						<div className="label-value">
							{actor?.known_for_department}
						</div>
					</div>
					<div className="actor-info mb-15">
						<span className="label">Gendar</span>
						<div className="label-value">
							{actor?.gender === 1 ? "Female" : "Male"}
						</div>
					</div>
					<div className="actor-info mb-15">
						<span className="label">Birthday</span>
						<div className="label-value">
							{actor?.birthday} ({age} years old)
						</div>
					</div>
					<div className="actor-info mb-15">
						<span className="label">Birth Location</span>
						<div className="label-value">
							<FontAwesomeIcon icon={faLocationDot} />
							{actor?.place_of_birth}
						</div>
					</div>

					<div className="actor-info mb-15">
						<div className="alt-names">
							<span className="label">Also knowen as</span>
							{actor.also_known_as?.map((name) => (
								<div key={name} className="label-value">
									{name}
								</div>
							))}
						</div>
					</div>
				</div>
				<div className="actor-full">
					<div className="actor-details">
						<h2 className="actor-title mb-15">{actor?.name}</h2>
						<div className="actor-info mb-15">
							<span className="label">Biography</span>
							<div className="label-value">
								{actor?.biography}
							</div>
						</div>
					</div>
					<div className="row">
						<h2>Images</h2>
						<div className="row__posters">
							{images?.map((image) => (
								<img
									className="row__poster row__posterLarge"
									src={`${base_url}${image?.file_path}`}
									alt=""
								/>
							))}
						</div>
					</div>
					<Row title="Known For" fetchUrl={popular} isLargeRow />
				</div>
			</Actor>
		</div>
	);
}

export default Actor;
